import React from 'react';
import { IProps, IChildElement } from 'components/Home/FlowRemind/types';
import Flow from 'components/Home/FlowRemind/Flow';
import Table from 'components/Home/FlowRemind/Table';
import Remind from 'components/Home/FlowRemind/Remind';

const FlowRemind: React.FC<IProps> & IChildElement = (props) => (
  <div className="flow-remind">
    <div className="template-container">
      <div className="template-content">
        <div className="flow-remind__title-section">
          <div className="flow-remind__title">{props.title}</div>
          {props.desc && (
            <p className="flow-remind__desc">{props.desc}</p>
          )}
        </div>
        {props.children}
      </div>
    </div>
  </div>
);

FlowRemind.Flow = Flow;
FlowRemind.Table = Table;
FlowRemind.Remind = Remind;

export default FlowRemind;
